import type { Report } from "../types";
import { formatDivergence } from "./format";

export function hasEstimate(report: Report): boolean {
  return report.ftmEstimateLow !== null && report.ftmEstimateLow !== undefined && report.ftmEstimateHigh !== null && report.ftmEstimateHigh !== undefined;
}

export function hasDivergence(report: Report): boolean {
  return report.divergenceLow !== null && report.divergenceLow !== undefined && report.divergenceHigh !== null && report.divergenceHigh !== undefined;
}

export function estimateLabel(report: Report): string {
  return hasEstimate(report) ? `${Math.round((report.ftmEstimateLow as number) * 100)}–${Math.round((report.ftmEstimateHigh as number) * 100)}%` : "Unavailable";
}

export function divergenceLabel(report: Report): string {
  if (!hasDivergence(report)) return "Unavailable";
  return formatDivergence(report.divergenceLow, report.divergenceHigh);
}

export function stateLabel(state: Report["state"]): string {
  return state === "unknown" ? "State unavailable" : state;
}

export function categoryLabel(category: Report["category"]): string {
  return category ? category : "Uncategorized";
}
